import { useRouter } from 'next/router';
import { slugify } from '@/utils/helpers';
import { ButtonLink } from './ButtonLink';

type ListNavigation = {
  list: {
    title?: string | null;
    href: string;
  }[];
};

export const PillNavigationList = ({ list }: ListNavigation) => {
  const { asPath } = useRouter();

  return (
    <nav>
      <ul className="list-none">
        {list.map(({ title, href }, index) => (
          <li key={`${index}-${slugify(title || 'Untitled')}`}>
            <ButtonLink
              className={`text-left justify-start relative mb-4 w-full border-base-100 justify-start" rel="nofollow noopener ${href === asPath ? 'text-primary-hover' : ''}`}
              variant="secondary"
              href={href}
              outline
            >
              {title || 'Untitled'}{' '}
              <span className="material-symbols-outlined absolute right-5 top-1/2 -translate-y-1/2">chevron_right</span>
            </ButtonLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
